import { Canvas } from '@react-three/fiber'
import { Suspense } from 'react'
import { Preload } from '@react-three/drei'
import { useState,useEffect} from "react";
import { useStore } from '../state/useStore'

// THREE components
import Ship from './Ship'
import Ground from './Ground'
import Skybox from './Skybox'
import Cubes from './Cubes'
import Walls from './Walls'
import CubeTunnel from './CubeTunnel'
import Effects from './Effects'

// State/dummy components
import KeyboardControls from './KeyboardControls'
import GameState from './GameState'
import GlobalColor from './GlobalColor'
import Music from './Music'
import Sound from './Sound'

// HTML components
import Overlay from './html/Overlay'
import Hud from './html/Hud'
import GameOverScreen from './html/GameOverScreen'






export default function CubeWorld({ color, bgColor }) {
  const directionalLight = useStore((s) => s.directionalLight);
  const [isGameReady, setIsGameReady] = useState(false); // Состояние готовности игры
  const canvasKey = useStore((s) => s.canvasKey);
  const resetGame = useStore((s) => s.resetGame);

  useEffect(() => {
    const initializeSDK = async () => {
      let attempts = 0;

      // Ожидаем, пока SDK загрузится
      while (!window.YaGames && attempts < 5) {
        console.log("Ожидание загрузки YaGames SDK...");
        await new Promise((resolve) => setTimeout(resolve, 50));
        attempts += 1;
      }

      if (window.YaGames) {
        try {
          const ysdk = await window.YaGames.init(); // Инициализация SDK
          window.ysdk = ysdk;
          console.log("Yandex SDK успешно инициализирован");

          // Показываем рекламу
          ysdk.adv.showFullscreenAdv({
            callbacks: {
              onClose: function (wasShown) {
                if (wasShown) {
                  console.log("Реклама была показана и закрыта, запускаем игру.");
                } else {
                  console.warn("Реклама была пропущена, но игра запускается.");
                }
                setIsGameReady(true); // Игра готова после показа рекламы
                ysdk.features.LoadingAPI?.ready();
              },
              onError: function (error) {
                console.error("Ошибка при показе рекламы:", error);
                setIsGameReady(true); // Разрешаем игру даже при ошибке
                ysdk.features.LoadingAPI?.ready();
              },
            },
          });
        } catch (err) {
          console.error("Ошибка при инициализации Yandex SDK:", err);
          setIsGameReady(true); // Разрешаем игру, если инициализация провалилась
        }
      } else {
        console.error("YaGames SDK недоступен. Убедитесь, что он загружается.");
        setIsGameReady(true); // Разрешаем игру, если SDK не загрузился
      }
    };

    initializeSDK();
  }, []);




  

  return (
    <>
      {!isGameReady ? ( // Пока игра не готова, показываем заглушку
        <div style={{ color: "white", textAlign: "center", marginTop: "50vh" }}>
          <h1>Загрузка...</h1>
        </div>
      ) : (
        <Canvas
          key={canvasKey}  // Используем key для перерисовки компонента
          gl={{ antialias: false, alpha: false }}
          mode="concurrent"
          dpr={[1, 1.5]}
          style={{ background: `${bgColor}` }}
        >
          <Suspense fallback={null}>
            <GameState />
            <Skybox />
            <directionalLight
              ref={directionalLight}
              intensity={3}
              position={[0, Math.PI, 0]}
            />
            <ambientLight intensity={0.1} />
            <Ship>
              {directionalLight.current && <primitive object={directionalLight.current.target} />}
            </Ship>
            <Walls />
            <Cubes />
            <CubeTunnel />
            <Ground groundColor={bgColor} />
            <KeyboardControls />
            <Effects />
            <GlobalColor />
            <Music />
            <Sound />
            <Preload all />
          </Suspense>
        </Canvas>
      )}
      {isGameReady && (
        <>
          <Hud />
          <GameOverScreen />
          <Overlay />
        </>
      )}
    </>
  );
}




